import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Header.less';

export default class HeaderStaticMap extends React.Component {
  render() {
    const containerStyles = this.props.url ? { backgroundImage: `url(${this.props.url})` } : {};

    return (
      <div id="static-map" className={styles.map} style={containerStyles}>
        {this.props.children}
      </div>
    );
  }
}

HeaderStaticMap.defaultProps = {
  url: null,
};

HeaderStaticMap.propTypes = {
  url: PropTypes.string,
};
